const dashboard = (axios) => {
  const vendorKpiMethod = (type, params) => {
    return axios.post(`dashboard/vendor/otherkpis/${type}`, params);
  };

  return {

    /**
         * @method get
         * @api /api/dashboard/projects
         */
    getProjects (params) {
      return axios.get('/dashboard/projects', {
        params: params,
      })
        .then((response) => response);
    },

    /**
         * @method get
         * @api /api/dashboard/doctypes
         */
    getDocType () {
      return axios.get('/dashboard/doctypes')
        .then((response) => response);
    },

    main: {

      /**
             * @param params
             * @method get
             * @api /api/dashboard/main/quality?projectId=${id}&status=${status}&created_on=${date}
             */
      getQuality (params) {
        return axios.get('/dashboard/main/quality', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param params
             * @method get
             * @api /api/dashboard/main/successful?source_language=${source_language}&target_language=${target_language}&type=${type}&doc_type=${params.doc_type}&created_on=${params.created_on}
             */
      getSuccessful (params) {
        return axios.get('/dashboard/main/successful', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param {source_language} Integer
             * @param {target_language} Integer
             * @param {created_on}      String
             * @param {page}            Integer
             * @param {ppage}           Integer
             * @method get
             * @api /api/dashboard/main/amount
             */
      getAmount (params) {
        return axios.get('/dashboard/main/amount', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param {source_language} Integer
             * @param {target_language} Integer
             * @param {created_on}      String
             * @method get
             * @api /api/dashboard/main/amount
             */
      getAverage (params) {
        return axios.get(`/dashboard/main/average/${params.type}`, {
          params: params,
        })
          .then((response) => response);
      },

    },

    map: {

      /**
             * @param {user_type}       String
             * @param {creation_date}   String
             * @param {industry_field}  Integer
             * @param {doc_type}        Integer
             * @method post
             * @api /api/dashboard/rating_map
             */
      getPoints (params) {
        return axios.post('/dashboard/rating_map', params)
          .then((response) => response);
      },
    },

    tq: {

      /**
             * @param {source_language} Integer
             * @param {target_language} Integer
             * @param {creation_date}   String
             * @param {industry_field}  Integer
             * @param {doc_type}        Integer
             * @method get
             * @api /api/dashboard/tq_mouth
             */
      getPointsEvolution (params) {
        return axios.get('/dashboard/tq_mouth', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param {source_language} Integer
             * @param {target_language} Integer
             * @param {creation_date}   String
             * @param {industry_field}  Integer
             * @param {doc_type}        Integer
             * @method get
             * @api /api/dashboard/tq_average
             */
      getPointsAverage (params) {
        return axios.get('/dashboard/tq_average', {
          params: params,
        })
          .then((response) => response);
      },
    },

    errorIntelligence: {

      /**
             * @param {CreationDate}        String
             * @param {Proofreaders}        String
             * @param {IndustryField}       String
             * @param {QaModels}            String
             * @param {Customers}           String
             * @param {QaExperts}           String
             * @param {DocType}             String
             * @param {QaEvaluationType}    String
             * @param {GlobalSearch}        String
             * @param {Statement}           String
             * @param {ErrorSeverity}       String
             * @param {ErrorPoints}         String
             * @param {Status}              String
             * @param {ErrorWeight}         String
             * @param {ErrorCategory}       String
             * @param {ErrorMetaRules}      String
             * @param {LangSearch}          Object
             * @param {Page}                Number
             * @param {PPage}               Number
             * @method post
             * @api /api/dashboard/intellengence/
             */
      get (params) {
        return axios.post('/dashboard/intellengence/', params)
          .then((response) => response);
      },

      /**
             * @method get
             * @api /api/user/intellegence/
             */
      getUser () {
        return axios.get('/user/intellegence/')
          .then((response) => response);
      },

    },

    overall: {

      /**
             * @param {source_language} Integer
             * @param {target_language} Integer
             * @param {creation_date}   String
             * @param {industry_field}  String
             * @param {doc_type}        String
             * @method get
             * @api /api/dashboard/overall
             */
      getOverallTranslationQuality (params) {
        return axios.get('/dashboard/overall/', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param {creation_date} String
             * @method get
             * @api /api/dashboard/overall/languages
             */
      getLangCombination (params) {
        return axios.get('/dashboard/overall/languages', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param {creation_date} String
             * @method get
             * @api /api/dashboard/overall/categories
             */
      getErrorCategories (params) {
        return axios.get('/dashboard/overall/categories', {
          params: params,
        })
          .then((response) => response);
      },

      /**
             * @param {creation_date} String
             * @method get
             * @api /api/dashboard/overall/severity
             */
      getErrorSeverity (params) {
        return axios.get('/dashboard/overall/severity', {
          params: params,
        })
          .then((response) => response);
      },
    },
    getVendorTrends (params) {
      return axios.post('/dashboard/vendor/get_trends', { ...params }).then((resp) => {
        return resp.data.Status ? resp.data.Data : Object();
      });
    },
    getVendorResults (params) {
      return axios.post('/dashboard/vendor/get_result', { ...params }).then((resp) => {
        return resp.data.Status ? resp.data.Data : Object();
      });
    },
    getCountriesTrends (params) {
      return axios.post('/dashboard/countries/trends', { ...params }).then((resp) => {
        return resp.data.Status ? resp.data.Data : Object();
      });
    },
    getVendorKpi: {
      language: (params) => {
        return axios.post('/dashboard/vendor/languages', params);
      },
      industry: (params) => vendorKpiMethod('industry', params),
      document: (params) => vendorKpiMethod('doctype', params),
      qaModel: (params) => vendorKpiMethod('qamodels', params),
      qaMethod: (params) => vendorKpiMethod('qamethods', params),
    },
    getCountriesKpi: {
      language: (params) => {
        return axios.post('/dashboard/countries/languages', params);
      },
    },
  };
};

export default dashboard;
